import script from "./NoteComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteComponent.vue?vue&type=script&setup=true&lang=js"

import "./NoteComponent.vue?vue&type=style&index=0&id=73f16475&lang=scss&scoped=true"

import exportComponent from "D:\\Front-End\\note-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73f16475"]])

export default __exports__